// Import utilities
import { builderFetch } from '@builder/core/utilities';
import { html } from 'lit';
const { confirm, isDefined } = _uo.utility;

// Translatable strings
const strings = UncannyAutomator._core.i18n.core.userSelector.setRequiresUserSelector;

/**
 * Set the requires user selector flag.
 *
 * @param {Boolean} requiresUserSelector Whether or not the recipe requires a user selector.
 * @return {Promise} The apiFetch promise
 */
const setRequiresUserSelector = async ( requiresUserSelector ) => {
	// If the item is not define, stop here
	if ( ! isDefined( requiresUserSelector ) ) {
		throw new Error( `setRequiresUserSelector: requiresUserSelector can't be empty` );
	}

	// If the user is trying to remove the user selector, we need to confirm it.
	if ( ! requiresUserSelector ) {
		await confirm( {
			content: html`
				<uo-alert type="warning">
					${ strings.warningMessage }
				</uo-alert>
			`
		} );
	}

	// Set the user selector
	return builderFetch( {
		endpoint: 'set_recipe_requires_user',
		method: 'POST',
		data: {
			recipePostID: UncannyAutomator._recipe.recipe_id,
			requiresUser: requiresUserSelector,
		},
		snackbar: {
			loading: strings.updatingFlag,
			success: strings.flagUpdated,
		}
	} ).then( response => {
		// Check if the call was successful
		if ( response.success ) {
			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( 'uap/builder/core/user-selector/set-requires-user-selector', {
				detail: {
					requiresUserSelector: requiresUserSelector
				}
			} ) );
		}

		return response;
	} );
}

export default setRequiresUserSelector;

